(ns practitest.frontend.permutations.views
  (:require
    [clojure.string :as string]
    [practitest.frontend.common-old-fe.i18n :as i18n]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.components2.entity-form :refer [breadcrumbs-view]]
    [practitest.frontend.permutations.events]
    [practitest.frontend.routing.backend-routes :as broutes]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(defn my-checkbox [item category]
  (let [state (re-frame/subscribe [:permutations/checkbox-state (:int-id category) (:id item)])]
    (fn [item category]
      [:input {:type      "checkbox"
               :checked   @state
               :on-change #(re-frame/dispatch [:permutations/set-checkbox-state
                                               (:int-id category)
                                               (:id item)
                                               (-> % .-target .-checked)])}])))

(defn select-button [section label value]
  [:span {:type     "button"
          :class    "fake-link form-label"
          :on-click #(re-frame/dispatch [:permutations/set-all-checkbox-state
                                         (:int-id section)
                                         value])}
   label])

(defn select-all-permutations-button [label value]
  [:span {:type     "button"
          :class    "fake-link"
          :on-click #(re-frame/dispatch (if value
                                          [:permutations/select-all-permutations]
                                          [:permutations/unselect-all-permutations]))}
   label])

(defn set-ids []
  (let [ids (re-frame/subscribe [:permutations/permutation-set-ids])]
    [:span (string/join ", " (sort @ids))]))

(defn name-set []
  [:span @(re-frame/subscribe [:permutations/name])])

(defn setids []
  [:span @(re-frame/subscribe [:permutations/selected-sets])])

(defn instances []
  [:span @(re-frame/subscribe [:permutations/selected-instances])])

(defn checkbox-section [category item]
  [:div {:class "clearfix inner"}
   [:div {:class "panel panel-default"}
    [:div {:class "panel-heading"}
     [:h5 (:display_name category)
      [:span {:class "actions float-right"}
       [select-button category (i18n/t :check_all) true]
       [:span " | "]
       [select-button category (i18n/t :uncheck_all) false]]]]
    [:div {:class "panel-body"}
     [:ul.item-list
      (for [[i f] (map-indexed vector item)]
        ^{:key i} [:div [:p [my-checkbox f category] " " (:name f)]])]]]])

(defn render-sections []
  (let [fields (re-frame/subscribe [:permutations/fields])]
    (fn []
      [:div
       (for [[i f] (map-indexed vector @fields)
             :when (= (:format f) "list")]
         ^{:key i} [:div [checkbox-section f (:options f)]])])))

(defn answers-list []
  (let [permutations (re-frame/subscribe [:permutations/permutations])
        permutations-checked (re-frame/subscribe [:permutations/permutations-checked])]
    (fn []
      (into [:div]
            (for [permutation @permutations]
              [:div.permutations-checkbox.edit.permutBox
               [:label
                [:input {:type      :checkbox
                         :checked   (boolean (get @permutations-checked permutation))
                         :on-change (fn [e]
                                      (re-frame/dispatch [:permutations/permutation-selected
                                                          permutation
                                                          (-> e .-target .-checked)]))}]
                (string/join " " (map :val permutation))]])))))

(defn selected-permutation []
  (let [test (re-frame/subscribe [:permutations/permutations-checked])]
    (fn []
      [:div
       (for [[i [permutation val]] (map-indexed vector @test)
             :when val]
         ^{:key i}
         [:label.permutBox (string/join " " (map :val permutation))])])))

(defn render-text-field [item]
  (let [value (re-frame/subscribe [:permutations/text-field-value (:int-id item)])
        state (reagent/atom nil)]
    (fn [item]
      [:div.clearfix>div.row
       [:label.col-sm-2.control-label
        {:htmlFor "exampleInputName2"}
        (:display_name item)]
       [:div.col-sm-10
        [:input.form-control.permutations-text-input
         {:type          :text
          :default-value @value
          :placeholder   (:display_name item)
          :ref           #(reset! state %)
          :on-change     #(re-frame/dispatch [:permutations/set-text-fields-value
                                              (:int-id item)
                                              (.-value @state)])}]]])))

(defn checkbox-create-failed-tests-only []
  [:p.clone-failed-only
   [:input {:type      "checkbox"
            :on-change #(re-frame/dispatch [:permutations/set-failed-tests-only-checkbox-state
                                            (-> % .-target .-checked)])}]
   [:span " Clone " [:b "FAILED"] " test instances " [:b "ONLY"]]])

(defn render-optional-text-field []
  (let [value (re-frame/subscribe [:permutations/optional-text])
        state (reagent/atom nil)]
    (fn []
      [:div {:class "clearfix optional-style"}
       [:div {:class "form-group"}
        [:div {:class "col-sm-12"}
         [:div (i18n/t :optional)]
         [:strong (i18n/t :create_a_filter_permutation)]]
        [:div {:class "col-sm-12"}
         [:input.form-control
          {:type          :text
           :default-value @value
           :ref           #(reset! state %)
           :on-change     #(re-frame/dispatch [:permutations/set-optional-text-value (.-value @state)])}]]
        [:div {:class "col-sm-12"}
         [checkbox-create-failed-tests-only]]]])))

(defn render-text-sections []
  (let [fields (re-frame/subscribe [:permutations/fields])]
    (fn []
      [:div
       (for [[i f] (map-indexed vector @fields)
             :when (= (:format f) "text")]
         ^{:key i} [:div [render-text-field f]])])))

(defn render-alert []
  [:div {:class "alert alert-gray"}
   [:div [:strong "Info"] [:h5 (i18n/t :editing_fields)]]
   [:p (i18n/t :select_checkbox_edit_field)]
   [:p (i18n/t :unchecked_value_edit_field)]])

(defn render-text-section-alert []
  [:div {:class "alert alert-gray"}
   [:div [:strong "Info"] [:h5 (i18n/t :editing_fields)]]
   [:p (i18n/t :text_fields_edit)]])

(defn render-text-section-container []
  (when (not-empty @(re-frame/subscribe [:permutations/text-fields]))
    [:div {:class "panel panel-default"}
     [:div {:class "panel-heading"}
      [:h4 (i18n/t :testset_text_fields)]]
     [:div {:class "panel-body row"}
      [:div {:class "col-md-6"}
       [:div [render-text-sections]]]
      [:div {:class "col-md-6"}
       [render-text-section-alert]]]]))

(defn permutations-breadcrumbes []
  [breadcrumbs-view {:breadcrumbs [{:href  (broutes/get-url-view "suites#index")
                                    :label (get-translation "navigation.project-menu.testsets" "Test sets & Runs")}]
                     :section     "Permutations"}])

(defn first-screen []
  [:div {:id "permutation_new"}
   [:div {:class "container-fluid permutations-container"}
    [permutations-breadcrumbes]
    [:h4 [name-set] (i18n/t :step_1_2)]
    [:hr]
    [:div
     [:form
      [:div {:class "panel panel-default"}
       [:div {:class "panel-heading"}
        [:h4 (i18n/t :testset_list_field)]]
       [:div {:class "panel-body row"}
        [:div {:class "col-md-6"}
         [:div [render-sections]]]
        [:div {:class "col-md-6"}
         [render-alert]]]]
      [render-text-section-container]
      [:div {:class "col-md-4 offset-md-4 text-center"}
       [:button.btn.btn-block.btn-primary.submit-form.marger_bottom
        {:type     :button
         :disabled @(re-frame/subscribe [:permutations/next-step-disabled?])
         :on-click #(re-frame/dispatch [:permutations/next-step])}
        (i18n/t :next_step)]
       [:span {:class "point_events"}
        [:a {:on-click #(re-frame/dispatch [:permutations/back-to-test-sets])}
         (i18n/t :cancel_and_go_back_to_testset)]]]]]]])

(defn testset-counter []
  [:span @(re-frame/subscribe [:permutations/testset-counter])])

(defn instances-counter []
  [:span @(re-frame/subscribe [:permutations/instances-counter])])

(defn instances-exceeded-error []
  (let [limit (re-frame/subscribe [:permutations/entities-limit])
        instances-counter (re-frame/subscribe [:permutations/instances-counter])]
    (fn []
      (if (< @limit @instances-counter)
        [:div {:class "row"}
         [:div {:class "col-md-12 bottom_alert"}
          [:div.alert.alert-danger.alertBtnMarger
           [:strong "Error!"] " Max number of " @limit " Instances exceeded"]]]))))

(defn second-screen []
  [:div {:class "container-fluid permutations-container"}
   [permutations-breadcrumbes]
   [:h4 [name-set] (i18n/t :step_2_2)]
   [:hr]
   [:div.row
    [:div {:class "col-md-6"}
     [:div {:class "col-md-12 row pd-left-30"}
      [instances-exceeded-error]
      [:div.col-md-6.paddZero
       [:h5 (i18n/t :select_permutations)]
       [answers-list]

       [:div {:class "checkboxesSelect"}
        [select-all-permutations-button (i18n/t :select_all) true]
        [:span "  |  "]
        [select-all-permutations-button (i18n/t :unselect_all) false]]]
      [:div.col-md-6.paddRightZero
       [:h5 (i18n/t :select_permutations)]
       [selected-permutation]]
      [instances-exceeded-error]]
     [:a.btn.btn-default.btn-outline-secondary.btnMargin
      {:on-click #(re-frame/dispatch [:permutations/prev-step])}
      (i18n/t :back)]
     [render-optional-text-field]]
    [:div {:class "col-md-6"}
     [:div {:class "alert alert-gray"}
      [:strong "Info"] [:h5 (i18n/t :editing_fields)]
      [:p (i18n/t :text_fields_edit)]]]]
   [:div {:class "row"}
    [:div {:class "col-md-12"}
     [:div {:class "col-md-4 offset-md-4"}
      [:p (i18n/t :this_operation_will_create)
       [:strong [testset-counter] (i18n/t :testsets)] (i18n/t :and) [:strong [instances-counter] (i18n/t :instances)]]
      [:button.btn.btn-block.btn-primary.submit-form.marger_bottom
       {:type     :button
        :disabled @(re-frame/subscribe [:permutations/finish-disabled?])
        ;  :disabled  (< @(re-frame/subscribe [:permutations/instances-exceeded]) @(re-frame/subscribe [:permutations/instances-counter]))
        :on-click (fn [_]
                    (.track js/mixpanel "Create permutations - finish")
                    (re-frame/dispatch [:permutations/submit]))}
       "Finish"]]]
    [:div {:class "col-md-4 offset-md-4 text-center link-back"}
     [:a {:on-click #(re-frame/dispatch [:permutations/back-to-test-sets])}
      (i18n/t :cancel_and_go_back_to_testset)]]]])

(defn main-panel []
  (if (= :first @(re-frame/subscribe [:permutations/screen]))
    [first-screen]
    [second-screen]))
